import { render, staticRenderFns } from "./QuasarTable.vue?vue&type=template&id=618d3f07&lang=pug&"
import script from "./QuasarTable.vue?vue&type=script&lang=js&"
export * from "./QuasarTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports